// LanguagesList.js

const LanguagesList = {
    languages: {
        "français": "fr",
        "deutsch": "de",
        "italiano": "it",
        "english": "en",
        "español": "es",
        "português": "pt",
        "afrikaans": "af",
        "arabic": "ar",
        "armenian": "hy",
        "azerbaijani": "az",
        "belarusian": "be",
        "bosnian": "bs",
        "bulgarian": "bg",
        "catalan": "ca",
        "chinese": "zh",
        "croatian": "hr",
        "czech": "cs",
        "danish": "da",
        "dutch": "nl",
        "estonian": "et",
        "finnish": "fi",
        "galician": "gl",
        "greek": "el",
        "hebrew": "he",
        "hindi": "hi",
        "hungarian": "hu",
        "icelandic": "is",
        "indonesian": "id",
        "japanese": "ja",
        "kannada": "kn",
        "kazakh": "kk",
        "korean": "ko",
        "latvian": "lv",
        "lithuanian": "lt",
        "macedonian": "mk",
        "malay": "ms",
        "marathi": "mr",
        "maori": "mi",
        "nepali": "ne",
        "norwegian": "no",
        "persian": "fa",
        "polish": "pl",
        "romanian": "ro",
        "russian": "ru",
        "serbian": "sr",
        "slovak": "sk",
        "slovenian": "sl",
        "swahili": "sw",
        "swedish": "sv",
        "tagalog": "tl",
        "tamil": "ta",
        "thai": "th",
        "turkish": "tr",
        "ukrainian": "uk",
        "urdu": "ur",
        "vietnamese": "vi",
        "welsh": "cy"
    },

    // Function to find the language name by its code
    keyForCode: function (code) {
        return Object.keys(this.languages).find(key => this.languages[key] === code);
    }
};

export default LanguagesList;
